import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { ProgressAction, ProgressGetter } from '@/store/progress/progress.module';
import { Progress, ProgressAttachment } from '@/store/progress/progress.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProcureImageModalComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    projectId: {
      type: Number,
    },
    progressId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const swal = useSweetAlert();
    const progress = computed<Progress | undefined>(() => store.getters[ProgressGetter.BY_ID](props.progressId));
    const images = computed<ProgressAttachment[]>(() => (progress.value?.attachments) ? progress.value?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const isLoading = computed(() => store.getters[ProgressGetter.STATUS] === 'init' || store.getters[ProgressGetter.STATUS] === 'loading');
    const imageModal = ref<InstanceType<typeof BaseModalComponent>>();
    const fileDialog = ref<HTMLInputElement>();

    // show modal
    const show = () => {
      imageModal.value?.show();
    };

    // hide modal
    const hide = () => {
      imageModal.value?.hide();
    };

    // open file dialog
    const fileDialogOpen = () => {
      fileDialog.value?.click();
    };

    const fileDialogChange = () => {
      const files = fileDialog.value?.files as FileList;
      store.dispatch(ProgressAction.ADD_ATTACHMENTS, {
        projectId: props.projectId,
        progressId: props.progressId,
        attachmentTypeId: 2,
        names: Array(files.length).fill('image'),
        attachments: files,
      });
    };

    const deleteImage = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ProgressAction.REMOVE_ATTACHMENTS, {
              projectId: props.projectId,
              progressId: props.progressId,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      images,
      imageModal,
      fileDialog,
      isLoading,
      show,
      hide,
      fileDialogOpen,
      fileDialogChange,
      deleteImage,
    };
  }
});
